import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { useForm } from "react-hook-form";

export default function Searcher({
    onSearch,
    onCancel
}) {
    const [btnDisabled, setBtnDisabled] = useState(true);

    const { 
        register, 
        handleSubmit, 
        setValue, 
        getValues,
    } = useForm({
        mode: "onChange",
        defaultValues: {
            id_original: '',
            referencia_pieza: '',
        }
    });

    const handleChangeReferencia = (e) => { 
        const value = e.target.value.trim();

        if(value !== '') setValue('referencia_pieza', value); 
        else setValue('referencia_pieza', ''); 

        checkIfIsEnabled();
    }

    const handleChangeID = (e) => { 
        const value = e.target.value.trim();

        if(value !== '') setValue('id_original', value); 
        else setValue('id_original', ''); 

        checkIfIsEnabled();
    }

    const checkIfIsEnabled = () => {
        if((getValues('referencia_pieza') !== '') || 
            (getValues('id_original') !== '') ||
            (
                (getValues('marca') !== 'null' && getValues('marca') !== null)
                
            )
        ) setBtnDisabled(false);
        else setBtnDisabled(true);
    }

    const handleSubmitSearch = (data) => {
        delete data.modelo;
        delete data.marca;
        delete data.tipo_pieza;
        onSearch(data);
    }

    return (
        <div className="w-100 d-flex flex-column mt-4 mt-md-0 mt-lg-0">
            <form className="form" onSubmit={handleSubmit(handleSubmitSearch)}>
                <div className="w-100 d-flex flex-wrap flex-md-nowrap align-items-center justify-content-between">
                    <div className="form-group me-0 me-md-3">
                        <label htmlFor="referencia_pieza">Referencia</label>

                        <input type="text"  
                            {...register("referencia_pieza")}
                            onChange={handleChangeReferencia}
                            defaultValue={''} />
                    </div>

                    <div className="form-group me-0 me-md-3">
                        <label htmlFor="id_original">ID</label>

                        <input type="text"  
                            {...register("id_original")}
                            onChange={handleChangeID}
                            defaultValue={''} />
                    </div>
                    <button 
                        disabled={btnDisabled}
                        type="submit" 
                        className="btn btn-primary mt-2"
                    >BUSCAR</button>
                    <span title="Cancelar" className="ms-3 mt-2" onClick={() => onCancel()}>
                        <FontAwesomeIcon icon={faTimes} size="1x" className="action" color="#dc3545" />
                    </span>
                </div>

                <small
                    style={{fontSize: '11px'}} 
                    className="text-uppercase mb-2">Busca por: ID | referencia</small>
            </form>
        </div>
    );
}